import {
  GET_MARKUP_DEDUCT_PERCENTAGE,
  SET_MARKUP_DEDUCT_PERCENTAGE,
  POST_MARKUP_DEDUCT_PERCENTAGE,
  DATA_UPDATED,
  GET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE,
  SET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE,
  GET_GOLD_SILVER_PRICE,
  SET_GOLD_SILVER_PRICE,
  SET_UPDATED_LIVE_QUOTES_PRICE,
  CHANGE_MARKUP_STATUS,
} from '../constants/MarkupDeductPercentage';

export const getMarkupDeductPercentage = () => {
  return {
    type: GET_MARKUP_DEDUCT_PERCENTAGE,
  };
};

export const setMarkupDeductPercentage = (markupDeductPercentage) => {
  return {
    type: SET_MARKUP_DEDUCT_PERCENTAGE,
    markupDeductPercentage,
  };
};

export const postMarkupDeductPercentage = (markupDeductPercentage) => {
  return {
    type: POST_MARKUP_DEDUCT_PERCENTAGE,
    markupDeductPercentage,
  };
};

export const dataUpdated = () => {
  return {
    type: DATA_UPDATED,
  };
};

export const getCurrentGoldAndSilverLiveQuotesPrice = () => {
  return {
    type: GET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE,
  };
};

export const setCurrentGoldAndSilverLiveQuotesPrice = (liveQuotesPrice) => {
  return {
    type: SET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE,
    liveQuotesPrice,
  };
};

export const getGoldSilverPrice = () => {
  return {
    type: GET_GOLD_SILVER_PRICE,
  };
};

export const setGoldSilverPrice = (currentGoldSilverPrice) => {
  return {
    type: SET_GOLD_SILVER_PRICE,
    currentGoldSilverPrice,
  };
};

export const setUpdatedLiveQuotesPrice = (updatedLiveQuotesPrice) => {
  return {
    type: SET_UPDATED_LIVE_QUOTES_PRICE,
    updatedLiveQuotesPrice,
  };
};

export const changeMarkupStatus = (data) => {
  return {
    type: CHANGE_MARKUP_STATUS,
    data: data,
  };
};
